import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';


const Modal = (props) => {

  const { config, open, openToggle, onCloseFunction } = props;

  let dialogueTitle = config.title ?? 'CritFail'; // Modal title
  let content = config.hasOwnProperty('content') ? config.content : ''; // Modal content

  let hasConfirmButton = config.hasOwnProperty('confirmButtonText')

  let confirmButtonText = config.hasOwnProperty('confirmButtonText') ? config.confirmButtonText : 'Yes'; // Confirm button text
  let closeButtonText = config.hasOwnProperty('closeButtonText') ? config.closeButtonText : 'Close'; // Close button text
  let dialogueId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);   // Random element id


  const confirmButton =
    <Button
      variant="contained"
      onClick={() => {
        openToggle()
        onCloseFunction();
      }}
      color="default"
    >
      {confirmButtonText}
    </Button>


  return (

    <Dialog
      open={open}
      aria-labelledby="confirm-dialog"
    >
      <DialogTitle id={dialogueId}>{dialogueTitle}</DialogTitle>


      <DialogContent>
        {content}
      </DialogContent>


      <DialogActions>
        <Button
          variant="contained"
          onClick={() => openToggle()}
          color="secondary"
        >
          {closeButtonText}
        </Button>


        { hasConfirmButton ? confirmButton : '' }


      </DialogActions>

    </Dialog>

  );
};
export default Modal;